import  "./About.css";
import header from './../../assets/images/header.svg';

const About = () => {
    

    return (
        <div className='about' id='about'>
            <img className='header-image' src={header} alt="header"/>
            <h3 className='aboutMe'>About Me</h3>
            <div className='body-container'>
                <h1 className='funFact'>I am a diligent problem sovler.</h1>
            </div>
            <div className='rectangle-container'>
                    <div className='desc-container'>
                        <h2 className='desc'>Since I was a boy, I had been fascinated by math and science which lead my to choose Physics as my main course of study in University. While learning Python for my physics labs, I began to understand the power of programming languages and their possibilities; I quickly enrolled in computer science course and began a minor. Now I use the unique problem solving skills I learned from my physics education, as well as, the determination I have strenghtened from such a rigorous course to excel in world of programming.</h2>
                    </div>
                    <div className='desc-blue'></div>
            </div>
        </div>
    )
}

export default About;